import { render, staticRenderFns } from "./info.vue?vue&type=template&id=0559d2a0&scoped=true"
import script from "./info.vue?vue&type=script&lang=js"
export * from "./info.vue?vue&type=script&lang=js"
import style0 from "./info.vue?vue&type=style&index=0&id=0559d2a0&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0559d2a0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data01/test/dev.console.insureforce.cn/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0559d2a0')) {
      api.createRecord('0559d2a0', component.options)
    } else {
      api.reload('0559d2a0', component.options)
    }
    module.hot.accept("./info.vue?vue&type=template&id=0559d2a0&scoped=true", function () {
      api.rerender('0559d2a0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/supervise/brokerInsuranceManage/info.vue"
export default component.exports